import React, { useEffect, useRef, useState } from 'react'
import { 
  Button,
  Card, 
  Grid, 
  makeStyles,
  TablePagination,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { 
  addPracticaAgrupada, 
  buscarPractica, 
  deletePracticasGrupo, 
  fetchPracticasGrupo, 
  savePracticasGrupo 
} from '../../../actions/autorizaciones/practicasAgrupadas';
import BuscadorAbm from '../../compartidos/abms/BuscadorAbm';
import BuscadorPractica from '../../turnos/coseguros/BuscadorPractica';
import { startAlerta } from '../../../actions/ui/alertas';
import { Cancel, Save } from '@material-ui/icons';
import AlertaMail from '../../empadronamiento/UI/AlertaMail';
import { PracticasAgrupadasTable } from './PracticasAgrupadasTable';

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 0.5,
    margin: 10,
  },
  card: {
    padding: 5,
  },
}));

export const FormPracticasAgrupadas = ({grupo, onlyRead = true, handleCloseModal}) => {
  const codigoPracticaRef = useRef(null);
  const dispatch = useDispatch();
  const classes = useStyles();

  const { practicas: items } = useSelector((state) => state.practicasAgrupadas);

  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [codigoPractica, setCodigoPractica] = useState(null);
  const [itemDelete, setItemDelete] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  
  useEffect(() => {
    dispatch(fetchPracticasGrupo(grupo.id));
  }, [dispatch]);

  const handleSearch = (textoBuscado) => {
    dispatch(buscarPractica(textoBuscado));
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSave = (e) => {
    e.preventDefault();

    if(items.length === 0){
      dispatch(startAlerta("Debe agregar una practica.", "warning", `¡Error!`));
    } else {
      dispatch(savePracticasGrupo(grupo.id, {idGrupo: grupo.id, practicas: items.map(item => item.idPractica)}, handleCloseModal))
    }

  };

  const onClickAgregarHandler = (e) => {
    if (codigoPractica) {
      if(!Array.isArray(items) || items?.filter(s => s.idPractica ===codigoPractica.idCodNom).length === 0){
        const practica = {
          idGrupo: grupo.id,
          idPractica: codigoPractica.idCodNom,
          practica: { codNom: codigoPractica.codNom, desNom: codigoPractica.desNom }
        };

        dispatch(addPracticaAgrupada(practica));
        codigoPracticaRef.current.resetValues();
        setCodigoPractica(null);
      } else {
        dispatch(startAlerta("La practica que intenta agregar ya existe", "warning", "Atencion"));
      }
    } else {
      dispatch(startAlerta("Ingrese una practica", "warning", "Atencion"));
    }
  };

  const handleDecision = (decicion = false) => {    
    if(decicion){
      setOpenModalDelete(false)
      dispatch(deletePracticasGrupo(grupo.id, itemDelete))
    }else{
      setOpenModalDelete(false)
      setItemDelete(null)
    }
  }

  return (
    <>
      <Grid container justify="center">
        <Grid item xs={12} md={10}>
          {onlyRead 
            ?
              <BuscadorAbm title="Buscar Prácticas" handleSearch={handleSearch} />
            :
              <Card className={classes.card}>
                <Grid container spacing={2} style={{ marginLeft: "auto", marginRight: "auto", marginTop: 5, marginBottom: 10 }}>
                  <Grid item xs={9}>
                    <BuscadorPractica
                      ref={codigoPracticaRef}
                      cod={codigoPractica}
                      label="Código o Nombre Practica"
                      fieldsDisabled={false}
                      laboratorio={true}
                      setCod={(val) => setCodigoPractica(val)}
                    />
                  </Grid>
                  <Grid item xs={3} >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={onClickAgregarHandler}
                    >
                      Agregar +
                    </Button>
                  </Grid>
                </Grid>
              </Card>
          }
        </Grid>
        <Grid item xs={12}>
          <PracticasAgrupadasTable 
            page={page} 
            items={items} 
            onlyRead={onlyRead} 
            rowsPerPage={rowsPerPage} 
            setItemDelete={setItemDelete} 
            setOpenModalDelete={setOpenModalDelete}
          />
        </Grid>
        {items.length > 0 && (
          <Grid item xs={12}>
            <TablePagination
              style={{ backgroundColor: "white" }}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={items.length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage="Registros por página"
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Grid>
        )}
      </Grid>
      {openModalDelete &&
        <AlertaMail
          open={openModalDelete}
          setOpen={setOpenModalDelete}
          mensaje={`Se va a eliminar práctica ${itemDelete?.practica?.codNom} - ${itemDelete?.practica?.desNom} , desea continuar?`}
          handleDecisionYes={() => handleDecision(true)}
          handleDecisionNo={handleDecision}
        />
        }
      <div style={{ textAlign: "right", marginTop: "2rem", paddingRight: 25, paddingBottom: 25 }}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Cancel />}
          onClick={handleCloseModal}
        >
          {onlyRead ? 'Cerrar' : 'Cancelar'}
        </Button>
        {!onlyRead &&
          <Button
            variant="contained"
            color="primary"
            startIcon={<Save />}
            style={{marginLeft: 50}}
            onClick={handleSave}
          >
            Aceptar
          </Button>
        }        
      </div>
    </>
  )
}
